module.exports = __webpack_public_path__ + "assets/img/footerTsa.545a3090.jpg";